import styled from 'styled-components'
import { Wrapper as ImageWrapper } from '../postImage/postImage.styles'

type WrapperProps = {
  $isEdit?: boolean
}

export const Wrapper = styled(ImageWrapper)<WrapperProps>`
  height: ${({ $isEdit }) => ($isEdit ? '10.188rem' : 'auto')};
  margin-top: ${({ $isEdit }) => ($isEdit ? '1.5rem' : '0')};

  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`

Wrapper.displayName = 'Wrapper'

export const PlayWrapper = styled.div`
  width: 2.875rem;
  height: 2.25rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

PlayWrapper.displayName = 'PlayWrapper'
